import _some from "./some";
var exports = {};
var some = _some;
/**
 * Check if object contains value
 */

function contains(obj, needle) {
  return some(obj, function (val) {
    return val === needle;
  });
}

exports = contains;
export default exports;